/**
 * @namespace video
 */

/**
 * Renderer selection constants — see {@link CANVAS}, {@link WEBGL},
 * {@link AUTO} and {@link WEBGPU}. Pass one as the `renderer` application
 * setting: `new Application(w, h, { renderer: video.WEBGL })`.
 */
export { AUTO, CANVAS, WEBGL, WEBGPU } from "../const";
